import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ComposicaoDoCustoAdd() {
  return (
    <div>
      <ContainerSection>
        <div>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="CDR" id="CDR" optionsArray={['']} widthPercentage="18%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Elemento do Custo" id="ElementoDoCusto" widthPercentage="18%" />
            <SelectAndOptions
              title="Categoria de Custo"
              id="CategoriaDeCusto"
              optionsArray={['', 'Material Direto', 'MDO Direta', 'CIF']}
              widthPercentage="18%"
            />
            <SelectAndOptions
              title="Unidade de Medida"
              id="UnidadeDeMedida"
              optionsArray={['', 'Hora/Homem', 'Hora/Máquina', 'kWh', 'Unidade', 'Galão', 'Litro']}
              widthPercentage="18%"
            />
            <SelectAndOptions
              title="Categoria da Unidade de Medida"
              id="CategoriaDaUnidadeDeMedida"
              optionsArray={['']}
              widthPercentage="18%"
            />
            <InputText title="Valor Unitário" id="ValorUnitario" widthPercentage="18%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error">Cancelar</button>
      </ButtonsGeneric>
    </div>
  );
}
